// extracted by mini-css-extract-plugin
export default {"page":"LandingContent_page__pR7mQ","container":"LandingContent_container__KzJbO","title":"LandingContent_title__DcZH4","deliveryContainer":"LandingContent_deliveryContainer__6+YR+"};